// extracted by mini-css-extract-plugin
module.exports = {"primaryPara":"Font_primaryPara__rgZPq","error":"Font_error__3FnX_"};